export class Radar {
    i: string[] | null;
    p: string;
    t: string;
    params: string;
    isSent: boolean;
    timeStamp: number;

    constructor(p?: string, t?: string) {
        this.p = Radar.normalizeKey(p);
        this.t = Radar.normalizeKey(t);
        this.i = [];
        this.params = '';
        this.isSent = false;
        this.timeStamp = Date.now();
    }

    static normalizeKey(key) {
        return String(key)
            .toLowerCase()
            .replace(/[^a-z0-9-]/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '')
            .slice(0, 63);
    }

    static throwError(error) {
        setTimeout(() => {
            throw error;
        }, 0);
    }

    static request(src) {
        return new Promise((resolve, reject) => {
            let img: null | HTMLImageElement = new Image();

            function handler(event) {
                if (img) {
                    img.removeEventListener('load', handler);
                    img.removeEventListener('error', handler);
                }
                img = null;

                if (event) {
                    clearTimeout(timeoutId);

                    if (event.type === 'load') {
                        resolve();
                    } else {
                        reject();
                    }
                } else {
                    reject('timeout');
                }
            }

            img.addEventListener('load', handler);
            img.addEventListener('error', handler);
            const timeoutId = setTimeout(handler, 3000);
            img.src = src;
        });
    }

    add(key, value?) {
        key = Radar.normalizeKey(key);

        if (value === undefined) {
            value = 1;
        } else if (
            typeof value !== 'number' ||
            !isFinite(value) ||
            value < 0 ||
            value > 4294967296 ||
            Math.floor(value) !== value
        ) {
            Radar.throwError(
                new Error(
                    'RadarError: invalid value (' + key + '=' + value + ')',
                ),
            );
            value = Math.min(Math.max(0, Math.round(value)), 4294967296) || 0;
        }

        if (this.i) {
            this.i.push(key + ':' + value);
        }

        return this;
    }

    time(key) {
        return this.add(key, Date.now() - this.timeStamp);
    }

    _param(key, value) {
        this.params += '&' + key + '=' + encodeURIComponent(value);

        return this;
    }

    param(key, value) {
        if (value === undefined) {
            Radar.throwError(
                new Error(
                    'RadarError: value is undefined (' +
                        key +
                        '=' +
                        value +
                        ')',
                ),
            );
        }

        return this._param(Radar.normalizeKey(key), value);
    }

    kaktam(filename, value) {
        return this._param('rlog', this.p + '_' + filename)._param(
            'rlog_message',
            JSON.stringify(value),
        );
    }

    send() {
        if (this.isSent) {
            return Promise.reject(
                Radar.throwError(
                    new Error('RadarError: already sent (' + this.t + ')'),
                ),
            );
        }

        let url =
            'https://stat.radar.imgsmail.ru/update?p=' +
            this.p +
            '&t=' +
            this.t +
            '&v=1&i=';

        if (this.i?.length) {
            url += this.i.join(',');
        } else {
            return Promise.reject(
                Radar.throwError(
                    new Error('RadarError: no counters (' + url + ')'),
                ),
            );
        }

        url += this.params;

        if (url.length > 5120) {
            return Promise.reject(
                Radar.throwError(
                    new Error('RadarError: overquota (' + url + ')'),
                ),
            );
        }

        this.i = null;
        this.isSent = true;

        return Radar.request(url);
    }
}
